import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTable, MatTableModule } from '@angular/material/table';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faGripLinesVertical } from '@fortawesome/free-solid-svg-icons';
import { Step } from '../../models/step';
import { OrderingStepDialogData } from './models/ordering-step-dialog-data';

/**
 * Composant de saisie des états d'une étape.
 * (Utilisable dans un formulaire et dans un MatFormField)
 */
@Component({
    selector: 'app-ordering-step-dialog',
    imports: [MatTableModule, MatIconModule, MatButtonModule, CdkDropList, FaIconComponent, CdkDragHandle, CdkDrag, NgClass, MatCardModule],
    templateUrl: './ordering-step-dialog.component.html',
    styleUrl: './ordering-step-dialog.component.scss'
})
export class OrderingStepDialogComponent {
    /**
     * Liste des icônes utilisés dans le template
     */
    public faGripLinesVertical = faGripLinesVertical;

    /**
     * Liste des colonnes affichées dans le tableau des états.
     */
    displayedColumns: string[] = ['order', 'name'];

    /**
     * Liste des enregistrements affichés dans le tableau.
     */
    steps = signal<Step[]>([]);

    /**
     * Réference à l'élément MatTable du template.
     */
    @ViewChild(MatTable, { read: ElementRef, static: true })
    table: ElementRef;

    /**
     * Titre de la boite de dialogue.
     */
    public title: string;

    /**
     * Constructeur.
     */
    constructor(
        public dialogRef: MatDialogRef<OrderingStepDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: OrderingStepDialogData
    ) {
        this.title = data.title;
        this.steps.update((steps) => data.items.sort((a, b) => a.data.order - b.data.order));
    }

    /**
     * Appellé lorsque l'utilisateur modifie l'ordre d'un état.
     * @param event : Instance de l'évènement de drag&drop.
     */
    public onStateDrop(event: CdkDragDrop<string[]>) {
        let steps = this.steps();
        moveItemInArray(steps, event.previousIndex, event.currentIndex);
        let index = 1;
        steps.forEach((x) => {
            x.data.order = index++;
        });

        this.steps.set(Step.cloneArray(steps));
    }

    /**
     * Appellé lorsque l'utilisateur valide le formulaire.
     */
    onConfirm(): void {
        let result: OrderingStepDialogData = { title: this.title, items: this.steps() };

        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    /**
     * Appellé lorsque l'utilisateur annule le formulaire.
     */
    onCancel(): void {
        // Close the dialog, return false
        this.dialogRef.close(null);
    }
}
